import { useEffect } from "react";

/**
 * Met à jour `<title>` et `<meta name="description">` en fonction de la page.
 *
 * Léger, sans dépendance (pas de react-helmet). Au démontage, on ne restore
 * pas l'ancienne valeur : la page suivante posera la sienne. Si une page n'a
 * pas de Seo, le title persiste — c'est suffisant pour une SPA mono-tenant.
 */
export const useSeo = ({ title, description, ogTitle, ogDescription } = {}) => {
  useEffect(() => {
    if (typeof document === "undefined") return;
    if (title) {
      document.title = title;
    }
    const setMeta = (selector, content) => {
      if (!content) return;
      const el = document.querySelector(selector);
      if (el) el.setAttribute("content", content);
    };
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', ogTitle || title);
    setMeta('meta[property="og:description"]', ogDescription || description);
    setMeta('meta[name="twitter:title"]', ogTitle || title);
    setMeta('meta[name="twitter:description"]', ogDescription || description);
  }, [title, description, ogTitle, ogDescription]);
};

export const Seo = (props) => {
  useSeo(props);
  return null;
};

export default Seo;
